import { VIDEO_MODEL_CANONICAL_ID } from '../../../../generated/modelCapabilities'

/** Display labels never replace the resolution stored or sent to a provider. */
export function getVideoResolutionDisplayName(model: string, resolution: string): string {
  const canonicalModel = VIDEO_MODEL_CANONICAL_ID[model] ?? model
  if (canonicalModel === 'minimax-h3-reference-to-video-atlas-cloud' && resolution === '1080p-esr') {
    return '1080P'
  }
  return resolution === 'auto' ? 'Auto' : resolution === '4k' ? '4K' : resolution
}
